import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=d55ba7da&scoped=true&"
import script from "./surveys.vue?vue&type=script&lang=js&"
export * from "./surveys.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./surveys.vue?vue&type=style&index=1&id=d55ba7da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55ba7da",
  null
  
)

component.options.__file = "surveys.vue"
export default component.exports